import * as React from 'react';

const ScreenSmallChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="screen-small-chunky_svg__eds-icon--screen-small-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="screen-small-chunky_svg__eds-icon--screen-small-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 18h2v-2h-2v2zm-2-4h6V6H9v8zM7 4v16h10V4H7z"
        />
    </svg>
);

ScreenSmallChunkySvg.displayName = 'ScreenSmallChunkySvg';
export default ScreenSmallChunkySvg;
